import _ from '#/lodash-extended';

export function addColorIfNotExist(colorSets, set) {
  const predicate = set.reduce((acc, el) => {
    acc[el.name] = el.value;
    return acc;
  }, {});
  const lookup = _.find(colorSets, predicate);
  if (!lookup) {
    colorSets.unshift(predicate);
  }
}

export function normalizeColor(clr) {
  if (typeof clr !== 'string') {
    return clr;
  }
  if (clr[0] === '#') {
    clr = clr.substring(1);
  }
  if (clr.length === 8) {
    clr = clr.substring(2).toLowerCase();
  }
  return '#' + clr;
}

export function normalizeColorSet(colorSet) {
  if (!colorSet?.length) {
    return;
  }
  for (const color of colorSet) {
    color.value = normalizeColor(color.value);
  }
}

export function logColorSet(colorSet, label) {
  if (!colorSet) {
    return;
  }
  console.groupCollapsed(label || 'Color Set');
  for (const color of colorSet) {
    const { name, value } = color;
    console.log(
      `${name}: ${value.toUpperCase()} %c          `,
      `background: ${value}`
    );
  }
  console.groupEnd();
}
